export const camList = [
  {
    name: "Rover 2.0",
    youtubeId: "tS2PHJmvJzo",
    streamUrl: "https://videobot.labpadre.com/cache/rover2/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=rover2",
  },
  {
    name: "Rover",
    youtubeId: "Rg7kw-KLDL8",
    streamUrl: "https://videobot.labpadre.com/cache/rover/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=rover",
  },
  {
    name: "Nerdle",
    youtubeId: "0EZQaF_liXw",
    streamUrl: "https://videobot.labpadre.com/cache/nerdle/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=nerdle",
  },
  {
    name: "Rocket Ranch",
    youtubeId: "qw3uaLRrYNY",
    streamUrl: "https://videobot.labpadre.com/cache/roost/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=roost",
  },
  {
    name: "Sentinel",
    youtubeId: "IQV0DlS1Ew0",
    streamUrl: "https://videobot.labpadre.com/cache/sentinel/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=sentinel",
  },
  {
    name: "Lab",
    youtubeId: "OWCh3wmKtak",
    //streamUrl: "https://videobot.labpadre.com/cache/lab/stream.m3u8",
    //streamUrl: "https://videobot.labpadre.com/autoplay.html?cam=lab",
  },
  {
    name: "Gator",
    youtubeId: "FTw5xuq2swo",
    //streamUrl: "https://videobot.labpadre.com/cache/gator/stream.m3u8",
  },
  {
    name: "Cape Cam",
    youtubeId: "k6VsTygpzZ4"
  }
];
